module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/frw"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/itr"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c01#c01a"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 1:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("The Power of Super Seeds")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c02#c02a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 2:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Basic Super Seed Recipes and Preparations")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c03#c03a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 3:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Breakfasts")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c04#c04a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 4:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Soups and Salads")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c05#c05a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 5:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Entrees")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c06#c06a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 6:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Baked Goods")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c07#c07a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Chapter 7:")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Desserts")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/bm#bma",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Super Seed Extras")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Conversion Charts")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/bm3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Frequently Asked Questions")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/res",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/crd",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("Credits")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 69
// module chunks = 0